import { combineReducers } from "redux";
import { Seo } from "../../types/index.js";
import crawler from "./crawler.js";
import urls from "./urls.js";

export default combineReducers<Seo>({ crawler, urls });
